export default __webpack_public_path__ + "images/d3c380fa53c6b0d5d0cad80f2c17322a.png";